export default __webpack_public_path__ + "static/media/clockClockwise.80a4b227.svg";